import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ion-text-wrap" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {onMounted, ref} from 'vue';
import {
  IonList,
  IonItem,
  IonListHeader,
  IonToolbar,
  IonLabel,
  IonButtons,
  IonButton,
  IonItemSliding,
  IonItemOption,
  IonItemOptions,
  IonIcon,
  IonReorder,
  IonReorderGroup,
  toastController, ItemReorderCustomEvent
} from "@ionic/vue";
import {MobiPointApiProfile} from "@/mobipoints/api/profile";
import {UserTrackingTemplate} from "@/mobipoints/profile/userTrackingTemplate/user_tracking_template.type";
import router from "@/router";
import * as icons from 'ionicons/icons';
import useProfileFactory from "@/composable/useProfileFactory";
import {AxiosError, AxiosResponse} from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserTrackingTemplateOverview',
  props: {
  showScrollToTop: {
    type: Boolean,
    default: false,
  },
  reorderDisabled: {
    type: Boolean,
    default: true,
  }
},
  setup(__props, { expose: __expose }) {

const props = __props;

onMounted(() => {
  loadUserTrackingTemplates();
});

const getContent = () => {
  return document.querySelector('ion-content');
};

const showUserTrackingTemplateDetail = (id: number) => {
  router.replace({
    name: 'UserTrackingTemplateDetail',
    params: {id: id}
  });
};

const { getProfileFactory } = useProfileFactory();

const scrollToTop = () => {
  const content = getContent();
  content && content.scrollToTop();
};

const userTrackingTemplates = ref<UserTrackingTemplate[]>([]);
const isReorderDisabled = ref<boolean>(props.reorderDisabled);

const loadUserTrackingTemplates = async function () {
  try {
    const response = await MobiPointApiProfile.getActiveUserTrackingTemplates();
    if (response.status !== 200) {
      throw new Error(response.data.error || 'Could not load user tracking templates');
    }

    userTrackingTemplates.value = getProfileFactory().createUserTrackingTemplateListByApiResponse(response.data);
  } catch (e) {
    console.log(e);
  }

};

const deleteUserTrackingTemplate = async function(id: number) {
  console.log(`delete user tracking template`,id);

  let response: AxiosResponse | null = null;
  let message = '';
  try {
    response = await MobiPointApiProfile.deleteUserTrackingTemplate(id);
    if (!response.data.status || response.data.status !== 'error') {
      userTrackingTemplates.value = userTrackingTemplates.value.filter((item) => item.id !== id);
      return;
    }

    message = `Could not delete tracking template error: ${response.data.message || 'Unkown'}` || message;
  } catch (error: any | AxiosError) {
    message = `Could not delete tracking template! Please try again :)`;
  }

  const toast = await toastController.create({
    message: message,
    position: 'bottom',
    duration: 3000,
    icon: icons.warning,
    buttons: [
      {
        side: 'end',
        role: 'cancel',
        icon: icons.close,
      }
    ],
  });

  return toast.present();
}

const doReorderUserTrackingTemplates = (event: ItemReorderCustomEvent) => {
  event.detail.complete(userTrackingTemplates.value);

  let sort = 1;
  userTrackingTemplates.value.forEach((val) => {
    val.sort = sort++;
  });

  MobiPointApiProfile.updateUserTrackingTemplateSorting(userTrackingTemplates.value);
}

const toggleReorderDisabled = () => {
  isReorderDisabled.value = !isReorderDisabled.value;
}

__expose({
  getContent,
  scrollToTop,
  toggleReorderDisabled,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_unref(IonList), { lines: "full" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonReorderGroup), {
          disabled: isReorderDisabled.value,
          onIonItemReorder: _cache[0] || (_cache[0] = ($event: any) => (doReorderUserTrackingTemplates($event)))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userTrackingTemplates.value, (userTrackingTemplate) => {
              return (_openBlock(), _createBlock(_unref(IonItemSliding), {
                detail: "",
                key: userTrackingTemplate.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    onClick: ($event: any) => (showUserTrackingTemplateDetail(userTrackingTemplate.id))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: userTrackingTemplate.userTrackingTrackType.getTrackTypeIcon()
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, _toDisplayString(userTrackingTemplate.name), 1),
                          _createElementVNode("p", _hoisted_1, [
                            _createTextVNode(_toDisplayString(userTrackingTemplate.getFormattedStartAndEndLocation().shift()) + " ", 1),
                            (userTrackingTemplate.getFormattedStartAndEndLocation().length > 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                  _hoisted_3,
                                  _createTextVNode(_toDisplayString(userTrackingTemplate.getFormattedStartAndEndLocation().pop()), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(IonReorder), { slot: "end" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_unref(IonItemOptions), { side: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItemOption), {
                        color: "danger",
                        onClick: ($event: any) => (deleteUserTrackingTemplate(userTrackingTemplate.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: icons.closeOutline
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode("löschen")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 512), [
      [_vShow, userTrackingTemplates.value.length > 0]
    ]),
    _withDirectives(_createVNode(_unref(IonListHeader), { lines: "full" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonLabel), null, {
          default: _withCtx(() => [
            _createTextVNode("Es sind noch keine Tracking Vorlagen vorhanden!")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, userTrackingTemplates.value.length === 0]
    ]),
    (_ctx.$props.showScrollToTop)
      ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: scrollToTop }, {
                  default: _withCtx(() => [
                    _createTextVNode("Scroll to Top")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})